import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const CANONICAL_ROUTES = {
  home: "/" as const,
  blog: "/blog/" as const,
  chiSono: "/chi-sono/" as const,
  prenota: "/prenota/" as const,
  testimonianze: "/testimonianze/" as const,
};

export const SITE_BASE_URL = "https://aura-counselling.com" as const;

export function withTrailingSlash(path: string): string {
  if (!path || path === "/" || path.startsWith("/#")) {
    return path || "/";
  }

  const searchIndex = path.indexOf("?");
  const hashIndex = path.indexOf("#");
  const boundary = [searchIndex, hashIndex]
    .filter((index) => index >= 0)
    .reduce<number>((acc, index) => (acc === -1 ? index : Math.min(acc, index)), -1);

  const pathname = boundary === -1 ? path : path.slice(0, boundary);
  const suffix = boundary === -1 ? "" : path.slice(boundary);

  if (pathname.endsWith("/")) {
    return `${pathname}${suffix}`;
  }

  return `${pathname}/${suffix}`;
}

export const buildBlogArticleRoute = (slug: string) => `/blog/${slug}/` as const;

export const resolveAppPath = (path: string): string => {
  if (!path || path === CANONICAL_ROUTES.home) {
    return CANONICAL_ROUTES.home;
  }

  return withTrailingSlash(path);
};

export const buildCanonicalUrl = (path: string): string => {
  if (!path) {
    return SITE_BASE_URL;
  }

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${SITE_BASE_URL}${resolveAppPath(path)}`;
};

type SnapAwareWindow = typeof window & { __REACT_SNAP__?: boolean };

export const isReactSnap = (): boolean => {
  if (typeof window !== "undefined") {
    const snapWindow = window as SnapAwareWindow;
    if (snapWindow.__REACT_SNAP__) {
      console.log("ReactSnap detected via window flag");
      return true;
    }
  }

  if (typeof navigator !== "undefined") {
    console.log("ReactSnap user agent check", navigator.userAgent);
    if (navigator.userAgent?.includes("ReactSnap")) {
      return true;
    }
  }

  return false;
};

export const getLazyLoading = (): HTMLImageElement["loading"] | undefined => {
  if (isReactSnap()) {
    return undefined;
  }

  return "lazy";
};
